import Image from "next/image";
import getConfig from "next/config";
import Link from "next/link";

import SubLayout from "@/containers/layout/LandingLayout/SubLayout";
import Border1TopRight from "@/public/intermediaries/border-top-right.svg";
import Border1BottomLeft from "@/public/intermediaries/border-bottom-left.svg";
import Border1BottomRight from "@/public/intermediaries/border-bottom-right.svg";
import Border1BottomLeftOpened from "@/public/intermediaries/border-bottom-left-opened.svg";
import Border1BottomRightOpened from "@/public/intermediaries/border-bottom-right-opened.svg";
import Border2BottomRight from "@/public/intermediaries/border-2-bottom-right.svg";
import Border2BottomRightOpened from "@/public/intermediaries/border-2-bottom-right-opened.svg";
import Border2TopLeft from "@/public/intermediaries/border-2-top-left.svg";
import Border2TopLeftMedium from "@/public/intermediaries/border-2-top-left-md.svg";
import Border3TopLeft from "@/public/intermediaries/border-3-top-left.svg";
import Border3TopRight from "@/public/intermediaries/border-3-top-right.svg";
import Border3BottomLeft from "@/public/intermediaries/border-3-bottom-left.svg";
import Border3BottomLeftOpened from "@/public/intermediaries/border-3-bottom-left-opened.svg";

import { FC, useState } from "react";

const { publicRuntimeConfig } = getConfig();

const PartnerWithKeyzy: FC = () => {
  const [showSection, setShowSection] = useState(false);
  const [showSection2, setShowSection2] = useState(false);
  const [showSection3, setShowSection3] = useState(false);

  return (
    <section className="relative flex flex-col bg-landing-ivory">
      <SubLayout allowOverflow>
        <h2 className="mb-6 text-4xl font-bold text-center md:text-5xl md:mb-16 ">
          Partner with Keyzy
        </h2>

        <div className="relative z-40 flex flex-col items-center w-full pb-0 md:pb-20 lg:pb-20 xl:pb-[9.5rem] md:flex-row md:justify-around md:items-start md:max-w-5xl xl:max-w-6xl md:mx-auto xl:justify-evenly justify-items-start">
          <div
            className={`flex  h-full ${
              showSection ? "md:min-h-[64.75rem] xl:min-h-[53.75rem]" : "xl:min-h-[28.25rem]"
            } md:w-[14.375rem] xl:w-[21.875rem]  relative w-full  max-w-[21.875rem] flex-col pb-4 lg:pb-5 pt-4 lg:pt-6 xl:pt-11 mb-10 md:mb-0 items-center md:px-5 bg-white rounded-[30px]`}
          >
            <>
              <Border1TopRight className="absolute right-1.5 -top-1.5" />
              <Border1BottomLeft
                className={`${!showSection ? "visible" : "hidden"} absolute left-[5px] -bottom-1`}
              />
              <Border1BottomRight
                className={`${
                  !showSection ? "visible" : "hidden"
                } absolute right-[7.5px] -bottom-1`}
              />
              <Border1BottomLeftOpened
                className={`${showSection ? "visible" : "hidden"} absolute left-[5px] bottom-0.5`}
              />
              <Border1BottomRightOpened
                className={`${showSection ? "visible" : "hidden"} absolute right-[5px] bottom-0.5`}
              />
            </>

            <h3 className="relative z-10 mb-7 text-3xl font-bold text-center text-landing-blue">
              Mortgage brokers
            </h3>
            <div className="relative min-w-[120px] min-h-[90px] xl:min-w-[139px] xl:min-h-[117px] mb-3 lg:mb-5 xl:mb-7">
              <Image
                src="/intermediaries/mortgage-brokers.svg"
                alt="Mortgage brokers"
                layout="fill"
                objectFit="contain"
              />
            </div>
            <div className="flex flex-col justify-around items-center">
              <p className="text-base text-center w-[16.625rem] md:w-full mb-4 xl:mb-7 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em] md:min-h-[115px] xl:min-h-full">
                Flexible, low-deposit solutions for mortgage brokers and specialist lending
                intermediaries.
              </p>
              {showSection && (
                <>
                  <p className="text-base text-center w-[16.625rem] md:w-full mb-6 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em]">
                    Advising your client on the best options for a mortgage can be tricky if their
                    circumstances don’t fit traditional lenders’ criteria.
                  </p>
                  <p className="text-base text-center w-[16.625rem] md:w-full mb-7 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em]">
                    <strong>At Keyzy, we can help your client </strong>
                    own a home if they:
                    <ul className="list-disc list-inside leading-[23px] tracking-[-0.011em]">
                      <li>Have no or a small deposit</li>
                      <li>Can’t borrow enough</li>
                      <li>New to the UK</li>
                      <li>Self-employed or in a new job</li>
                      <li>Stuck renting or poor credit history.</li>
                    </ul>
                  </p>
                  <p className="text-base text-center w-[16.625rem] md:w-full mb-7 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em]">
                    <strong>With competitive commission </strong>
                    for successful referrals, Mortgage brokers and advisers can do more with Keyzy.
                  </p>
                </>
              )}
              <div
                className="relative flex flex-row text-landing-orange font-bold cursor-pointer font-base mb-4"
                onClick={() => setShowSection(!showSection)}
              >
                <p className="mr-2">{showSection ? "Read less" : "Read more"}</p>
                <Image
                  src="/budget-calculator/chevron-orange-bottom.svg"
                  width={11}
                  height={6}
                  alt="down chevron"
                  className={`transition-all duration-300 ease-in-out ${
                    showSection ? "rotate-180" : "rotate-0"
                  }`}
                />
              </div>
              <Link href={`${publicRuntimeConfig?.BROKER_PORTAL_URL}/sign-up`}>
                <a className="relative min-w-[8.5rem] z-40 inline-block w-full px-4 py-3 text-base font-bold text-center text-white transition duration-300 ease-in-out transform rounded shadow md:w-fit bg-landing-orange hover:scale-105">
                  Join the network
                </a>
              </Link>
            </div>
          </div>

          <div
            className={`flex h-full ${
              showSection2 ? "md:min-h-[64.75rem] xl:min-h-[53.75rem]" : "xl:min-h-[28.25rem]"
            }  md:w-[14.375rem] xl:w-[21.875rem]  relative w-full  max-w-[21.875rem] flex-col pb-4 lg:pb-5 pt-4 lg:pt-6 xl:pt-11 mb-10 md:mb-0 items-center md:px-5 bg-white rounded-[30px]`}
          >
            <>
              <Border2TopLeft className="hidden xl:flex absolute left-2 -top-1.5" />
              <Border2TopLeftMedium className="visible xl:hidden absolute left-2 -top-1.5" />
              <Border2BottomRight
                className={`${
                  !showSection2 ? "visible" : "hidden"
                } absolute right-[7px] -bottom-[6px]`}
              />
              <Border2BottomRightOpened
                className={`${
                  showSection2 ? "visible" : "hidden"
                } absolute right-[6px] bottom-[3px]`}
              />
            </>
            <h3 className="relative z-10 mb-7 text-3xl font-bold text-center text-landing-blue">
              Estate <br className="xl:hidden" /> agents
            </h3>
            <div className="relative min-w-[120px] min-h-[90px] xl:min-w-[139px] xl:min-h-[117px] mb-3 lg:mb-5 xl:mb-7">
              <Image
                src="/intermediaries/estate-agents.svg"
                alt="estate agents"
                layout="fill"
                objectFit="contain"
              />
            </div>
            <div className="flex flex-col justify-around items-center">
              <p className="text-base text-center w-[16.625rem] md:w-full mb-4 xl:mb-7 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em] md:min-h-[115px] xl:min-h-full">
                Close more deals faster, and grow your revenue by partnering with Keyzy.
              </p>
              {showSection2 && (
                <>
                  <p className="text-base text-center w-[16.625rem] md:w-full mb-7 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em]">
                    Estate agents know the difficulty working with potential buyers who struggle to
                    arrange financing through a mortgage.
                  </p>

                  <p className="text-base text-center w-[16.625rem] md:w-full mb-6 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em]">
                    <strong>At Keyzy, we can help your client </strong>
                    arrange an alternative path to home ownership through our innovative rent to buy
                    product.
                  </p>
                  <p className="text-base text-center w-[16.625rem] md:w-full mb-6 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em]">
                    Letting and estate agents can use Keyzy to refer clients looking for a way onto
                    the property ladder when traditional lending can’t help.
                  </p>
                  <p className="text-base text-center w-[16.625rem] md:w-full mb-1 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em]">
                    Sign up today to make referrals and
                    <strong> start earning commission.</strong>
                  </p>
                </>
              )}
              <div
                className="relative flex flex-row text-landing-orange font-bold cursor-pointer font-base mb-4"
                onClick={() => setShowSection2(!showSection2)}
              >
                <p className="mr-2">{showSection2 ? "Read less" : "Read more"}</p>
                <Image
                  src="/budget-calculator/chevron-orange-bottom.svg"
                  width={11}
                  height={6}
                  alt="down chevron"
                  className={`transition-all duration-300 ease-in-out ${
                    showSection2 ? "rotate-180" : "rotate-0"
                  }`}
                />
              </div>
              <Link href={`${publicRuntimeConfig?.BROKER_PORTAL_URL}/sign-up`}>
                <a className="relative min-w-[8.5rem] z-40 inline-block w-full px-4 py-3 text-base font-bold text-center text-white transition duration-300 ease-in-out transform rounded shadow md:w-fit bg-landing-denim hover:scale-105">
                  Sign up now
                </a>
              </Link>
            </div>
          </div>

          <div
            className={`flex h-full ${
              showSection3 ? "md:min-h-[64.75rem] xl:min-h-[53.75rem]" : "xl:min-h-[28.25rem]"
            }  md:w-[14.375rem] xl:w-[21.875rem]  relative w-full  max-w-[21.875rem] flex-col pb-4 lg:pb-5 pt-4 lg:pt-6 xl:pt-11 mb-0 items-center md:px-5 bg-white rounded-[30px]`}
          >
            <>
              <Border3TopLeft className="absolute left-[3.5px] -top-[5.5px]" />
              <Border3TopRight className="absolute right-[5.5px] -top-[5.5px]" />
              <Border3BottomLeft
                className={`${
                  !showSection3 ? "visible" : "hidden"
                } absolute left-[3px] -bottom-[1px]`}
              />
              <Border3BottomLeftOpened
                className={`${
                  showSection3 ? "visible" : "hidden"
                } absolute left-[3px] -bottom-[1px]`}
              />
            </>
            <h3 className="relative z-10 mb-7 text-3xl font-bold text-center text-landing-blue">
              Other partners
            </h3>
            <div className="relative min-w-[120px] min-h-[90px] xl:min-w-[139px] xl:min-h-[117px] mb-3 lg:mb-5 xl:mb-7">
              <Image
                src="/intermediaries/other-partners.svg"
                alt="other partners"
                layout="fill"
                objectFit="contain"
              />
            </div>
            <div className="flex flex-col justify-around items-center">
              <p className="text-base text-center w-[16.625rem] md:w-full mb-4 xl:mb-7 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] md:min-h-[115px] xl:min-h-full">
                Partner solutions for advisers, accountants, conveyancers and other home buying
                professionals.
              </p>

              {showSection3 && (
                <>
                  <p className="text-base text-center w-[16.625rem] md:w-full mb-7 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em]">
                    Whether you’re looking to support your client work towards their goal of home
                    ownership, or helping someone buy their first home, Keyzy would love to work
                    with you.
                  </p>
                  <p className="text-base text-center w-[16.625rem] md:w-full mb-6 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em]">
                    <strong>At Keyzy, we help clients and home buying professionals </strong>
                    achieve their goals through our rent to buy product. We make the dream of home
                    ownership a reality again.
                  </p>
                  <p className="text-base text-center w-[16.625rem] md:w-full mb-1 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em]">
                    We pay our partners a competitive commission for successful referrals. So if
                    you’re interested feel free to get in touch or sign up to begin making referrals
                    today.
                  </p>
                </>
              )}

              <div
                className="relative flex flex-row text-landing-orange font-bold cursor-pointer font-base mb-4"
                onClick={() => setShowSection3(!showSection3)}
              >
                <p className="mr-2">{showSection3 ? "Read less" : "Read more"}</p>
                <Image
                  src="/budget-calculator/chevron-orange-bottom.svg"
                  width={11}
                  height={6}
                  alt="down chevron"
                  className={`transition-all duration-300 ease-in-out ${
                    showSection3 ? "rotate-180" : "rotate-0"
                  }`}
                />
              </div>
              <Link href={`${publicRuntimeConfig?.BROKER_PORTAL_URL}/sign-up`}>
                <a className="relative min-w-[8.5rem] z-40 inline-block w-full px-4 py-3 text-base font-bold text-center text-white transition duration-300 ease-in-out transform rounded shadow md:w-fit bg-landing-cherry hover:scale-105">
                  Join today
                </a>
              </Link>
            </div>
          </div>
        </div>
      </SubLayout>
      <div className="absolute -bottom-32 md:-bottom-20 xl:-bottom-12 left-0 right-0 m overflow-hidden bg-repeat-x h-24 md:h-32 xl:h-48 bg-[url('/intermediaries/city-outline-mobile.svg')]  md:bg-[url('/intermediaries/city-outline-tablet.svg')] xl:bg-[url('/intermediaries/city-outline-desktop.svg')]" />
    </section>
  );
};

export default PartnerWithKeyzy;
